<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="Confirm" lazy-validation>
          <v-card class="elevation-12">
            <v-card-title primary-title class="primary">
              <div class="headline white--text">Set New Password</div>
            </v-card-title>
            <v-card-text>
              <p>
                You are required to reset your password. If you have not received a code, please fill out your username
                and click "Request Code" to request a new one.
              </p>
            </v-card-text>
            <v-card-text>
              <v-text-field
                autocomplete="username"
                prepend-icon="person"
                name="username"
                label="Username"
                :rules="nameRules"
                :disabled="loading"
                v-model="user.username"
                type="text">
              </v-text-field>
              <v-text-field
                autocomplete="password"
                id="oldPassword"
                prepend-icon="lock"
                name="oldPassword"
                label="Old Password"
                :rules="passwordRules"
                :disabled="loading"
                v-model="user.password"
                type="password">
              </v-text-field>
              <v-text-field
                autocomplete="new-password"
                id="newPassword"
                prepend-icon="lock"
                name="newPassword"
                label="New Password"
                :rules="passwordRules"
                :disabled="loading"
                v-model="user.newPassword"
                type="password">
              </v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="Confirm"
                :loading="loading"
                type="submit">
                Set New Password
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'NewPasswordRequired',
    data() {
      return {
        loading: false,
        nameRules: [
          (v) => !!v || 'Username ist ein Pflichtfeld',
          (v) => (v && v.length <= 10) || 'Username must be less than 10 characters',
        ],
        passwordRules: [
          (v) => !!v || 'Passwort ist ein Pflichtfeld',
        ],
        user: {
          username: null,
          oldPassword: null,
          newPassword: null,
        },
      };
    },
    computed: {
      ...mapGetters({
        username: 'guest/auth/username',
        oldPassword: 'guest/auth/oldPassword',
      }),
    },
    methods: {
      ...mapActions({
        completeNewPassword: 'guest/auth/completeNewPassword',
        showSnackbar: 'common/snackbar/success',
      }),
      Confirm(e) {
        e.preventDefault();
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.completeNewPassword(this.user)
            .then((res) => {
              this.loading = false;
              if (res) {
                this.showSnackbar('New Password set');
                this.$router.push({name: 'SignIn'});
              }
            });
        }
      },
    },
    mounted() {
      if (this.username) {
        this.user.username = this.username;
      }
      if (this.oldPassword) {
        this.user.oldPassword = this.oldPassword;
      }
    },
  };
</script>

<style scoped>

</style>
